import gql from "graphql-tag";
import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import { ApolloInjection, QueryResult } from "@zapier/checkout/esm/types";
import { zapsToBePaused as ZapsToBePausedData } from "@zapier/checkout/esm/graphql-types";

export const zapsToBePausedQuery = gql`
  query zapsToBePaused($accountId: ID!, $planId: ID!) {
    zapsToBePaused(accountId: $accountId, planId: $planId) {
      id
    }
  }
`;

type Input = {
  accountId: number | string | undefined;
  planId: number | string | undefined;
} & ApolloInjection;

export const useZapsToBePaused = ({
  accountId,
  planId,
  useQuery = defaultUseQuery,
}: Input) => {
  const { data, loading, error }: QueryResult<ZapsToBePausedData> = useQuery(
    zapsToBePausedQuery,
    {
      skip: !accountId || !planId,
      variables: { accountId, planId },
      fetchPolicy: "network-only",
    }
  );

  return {
    zaps: data?.zapsToBePaused ?? [],
    isLoading: loading,
    error: error ? "There was an issue loading data. Please try again" : null,
  };
};
